import { IDirective } from 'angular';

export class NvInputNumberLimiter implements IDirective {
  restrict: string;
  replace: boolean;
  require: string;

  constructor() {
    this.restrict = 'A';
    this.replace = false;
    this.require = 'ngModel';
  }

  //  if value entered is greater than max allowed, blocks user's value and set value to max
  link($scope, $element, $attributes, ngModelCtrl) {
    $element.on('keydown keyup', e => {
      let aboveMax = Number($element.val()) > Number($attributes.max);

      if (
        aboveMax &&
        e.keyCode !== 46 && // delete
        e.keyCode !== 8 // backspace
      ) {
        e.preventDefault();
        if (Number($element.val()) === undefined) $element.val(parseInt($attributes.min));
        // set input value to max
        if (aboveMax) $element.val(parseInt($attributes.max));
        // update both view and model
        ngModelCtrl.$setViewValue();
      }
    });
  }
}
